module.exports = __webpack_public_path__ + "static/media/not_found.6695af99.svg";